import { getIcon } from '@utils/icons'
import styles from './HeaderBrand.module.sass'

export type BrandType = 'provenza' | 'emilceramica' | 'ergon' | 'viva' | 'level' | 'acif'

interface Props {
  brand: BrandType
  className?: string
}

const HeaderBrand = (props: Props) => {
  const { brand = undefined, className = '' } = props

  const icon = getIcon(`brand_${brand === 'emilceramica' ? 'emil' : brand}`)

  return icon ? (
    <div className={`${styles.root} ${styles[`root--${brand}`]} ${className} `}>{icon}</div>
  ) : (
    <></>
  )
}

export default HeaderBrand
